import React from "react";
import Seo from "@/components/Seo";
import PublicLayout from "@/components/layout/PublicLayout";
import PageHeader from "@/components/PageHeader";

const CONTENT = {
  "privacy-policy": {
    title: "Privacy Policy",
    body: [
      "Dreamzz HR & Consultancy ('we', 'us') respects your privacy. This policy explains how we collect, use and protect your personal information.",
      "Information we collect: When you register, submit a resume, apply for a job or contact us, we collect details such as your name, contact information, qualifications, experience and resume documents.",
      "How we use it: We use your information solely to provide recruitment and staffing services — matching candidates with suitable job opportunities and sharing relevant profiles with prospective employers.",
      "Data protection: Candidate documents and personal data are stored securely and are never exposed publicly. Only authorised staff may access resumes for recruitment purposes.",
      "Your rights: You may request access to, correction of, or deletion of your personal data at any time by contacting us.",
      "Consent: By using our services you consent to this policy.",
    ],
  },
  "terms": {
    title: "Terms & Conditions",
    body: [
      "By accessing and using this website and services of Dreamzz HR & Consultancy, you agree to these terms.",
      "Services: We provide manpower recruitment, staffing and HR consultancy services. Job listings are provided in good faith based on employer requirements.",
      "Candidate responsibility: You are responsible for the accuracy of the information and documents you submit.",
      "No guarantee: While we work diligently to match candidates and employers, we do not guarantee placement or hiring outcomes.",
      "Fees: Any applicable charges are communicated transparently before engagement.",
      "Changes: We may update these terms from time to time.",
    ],
  },
  "disclaimer": {
    title: "Disclaimer",
    body: [
      "The information on this website is provided for general informational purposes only.",
      "Job listings are based on information provided by employers and are subject to change or withdrawal without notice.",
      "Dreamzz HR & Consultancy is not liable for any decisions made based on the content of this website.",
      "We are not responsible for the content or practices of any third-party websites linked from this site.",
    ],
  },
  "cookie-policy": {
    title: "Cookie Policy",
    body: [
      "This website uses cookies and similar technologies to improve your browsing experience and analyse site traffic.",
      "Essential cookies: Required for basic site functionality such as authentication.",
      "Analytics cookies: Help us understand how visitors use the site (e.g. Google Analytics) so we can improve it.",
      "Managing cookies: You can control or disable cookies through your browser settings. Disabling some cookies may affect site functionality.",
    ],
  },
};

export default function Legal({ page }) {
  const c = CONTENT[page] || CONTENT["privacy-policy"];
  return (
    <PublicLayout>
      <Seo title={c.title} description={`${c.title} — Dreamzz HR & Consultancy`} />
      <PageHeader eyebrow="Legal" title={c.title} />
      <section className="max-w-3xl mx-auto px-4 sm:px-6 py-12 space-y-4">
        {c.body.map((p, i) => <p key={i} className="text-slate-300 leading-relaxed">{p}</p>)}
        <p className="text-slate-500 text-sm mt-8">Last updated: {new Date().toLocaleDateString()}</p>
      </section>
    </PublicLayout>
  );
}
